// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) { });

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    if (!LinkGoSecondSection) return;

    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)",
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;

    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

//Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;

    const offset = isMobile ? 220 : 280;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top:
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]:not(.anchorlink)').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Lenis Smooth Scroll
window.addEventListener("load", function () {
    if (typeof Lenis !== "undefined") {
        new Lenis({
            autoRaf: true,
        });
    }
});

//slider latest insights
window.addEventListener("load", () => {
    if (typeof Swiper === "undefined") return;
    document
        .querySelectorAll(".latest-insights__slider.swiper")
        .forEach((el) => {
            const nav = el.querySelector(".latest-insights__nav");
            const currentEl = nav ? nav.querySelector(".current") : null;
            const totalEl = nav ? nav.querySelector(".total") : null;
            const slideCount = el.querySelectorAll(".swiper-slide").length;

            const swiper = new Swiper(el, {
                slidesPerView: "auto",
                loop: slideCount > 4,
                slidesPerGroup: 1,
                spaceBetween: 30,
                watchOverflow: true,
                grabCursor: true,

                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },

                    992: {
                        slidesPerView: 3,
                    },

                    1200: {
                        slidesPerView: 4,
                    }
                },

                navigation: {
                    nextEl: el.querySelector(".swiper-button-next"),
                    prevEl: el.querySelector(".swiper-button-prev"),
                },

                on: {
                    init() {
                        if (!currentEl || !totalEl) return;
                        totalEl.textContent = this.slides.length;
                        currentEl.textContent = this.realIndex + 1;
                    },
                    slideChange() {
                        if (!currentEl) return;
                        currentEl.textContent = this.realIndex + 1;
                    },
                },
            });

            window.addEventListener("resize", () => swiper.update());
        });
});

//slider latest insights single
window.addEventListener("load", () => {
    if (typeof Swiper === "undefined") return;
    document
        .querySelectorAll(".latest-insights__slider-single.swiper")
        .forEach((el) => {
            const nav = el.querySelector(".latest-insights__nav");
            const currentEl = nav ? nav.querySelector(".current") : null;
            const totalEl = nav ? nav.querySelector(".total") : null;
            const slideCount = el.querySelectorAll(".swiper-slide").length;

            const swiper = new Swiper(el, {
                slidesPerView: "auto",
                loop: slideCount > 4,
                slidesPerGroup: 1,
                spaceBetween: 30,
                watchOverflow: true,
                grabCursor: true,

                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },

                    992: {
                        slidesPerView: 3,
                    },

                    1200: {
                        slidesPerView: 4,
                    }
                },

                navigation: {
                    nextEl: el.querySelector(".swiper-button-next"),
                    prevEl: el.querySelector(".swiper-button-prev"),
                },

                on: {
                    init() {
                        if (!currentEl || !totalEl) return;
                        totalEl.textContent = this.slides.length;
                        currentEl.textContent = this.realIndex + 1;
                    },
                    slideChange() {
                        if (!currentEl) return;
                        currentEl.textContent = this.realIndex + 1;
                    },
                },
            });

            window.addEventListener("resize", () => swiper.update());
        });
});
// Slider Gallery
window.addEventListener("load", () => {
    if (typeof Swiper === "undefined") return;
    document
        .querySelectorAll(".slider-gallery .gallery-slider.swiper")
        .forEach((el) => {
            new Swiper(el, {
                slidesPerView: 1,
                loop: true,
                spaceBetween: 29,
                grabCursor: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 29,
                    },
                    2000: {
                        slidesPerView: 4,
                        spaceBetween: 29,
                    },
                },
                navigation: {
                    nextEl: el.querySelector(".swiper-button-next"),
                    prevEl: el.querySelector(".swiper-button-prev"),
                },
            });
        });
});

jQuery(window).on("load", function () { var $ = jQuery;
    const $slider = $(".featured-resources-slider");
    if (!$slider.length) return;
    if (typeof $.fn.slick !== "function") return;

    const $counter = $(".featured-counter");
    const $current = $counter.find(".current");
    const $total = $counter.find(".total");

    $slider.on(
        "init reInit afterChange",
        function (event, slick, currentSlide) {
            const i = (currentSlide ? currentSlide : 0) + 1;
            $current.text(i);
            $total.text(slick.slideCount);
        },
    );

    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        adaptiveHeight: true,
    });

    $(".featured-prev").on("click", function () {
        $slider.slick("slickPrev");
    });

    $(".featured-next").on("click", function () {
        $slider.slick("slickNext");
    });
});

// Content Tabs mobile slider
jQuery(window).on("load", function () { var $ = jQuery;
    $(".block-tabs-cards-content--tabs").each(function () {
        const $tabsMobile = $(this).find(".tabs-mobile");
        if (!$tabsMobile.length) return;

        let slickInitialized = false;
        const $block = $(this);

        if (!$block.find(".tabs-slider-nav").length) {
            $block.append(
                '<div class="tabs-slider-nav"><div class="arrows-wrap"><button class="slick-prev">‹</button><span class="tabs-slider-counter"></span><button class="slick-next">›</button></div></div>',
            );
        }
        const $nav = $block.find(".tabs-slider-nav");
        const $counter = $nav.find(".tabs-slider-counter");

        function handleTabsMobile() {
            if (window.innerWidth <= 767) {
                if (!slickInitialized) {
                    $tabsMobile.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        dots: false,
                        arrows: true,
                        prevArrow: $nav.find(".slick-prev"),
                        nextArrow: $nav.find(".slick-next"),
                    });

                    const total = $tabsMobile.slick("getSlick").slideCount;

                    if (total <= 1) {
                        $nav.hide();
                    } else {
                        $nav.show();
                        $counter.text(`1 / ${total}`);
                        $tabsMobile.on(
                            "afterChange",
                            function (event, slick, currentSlide) {
                                $counter.text(
                                    `${currentSlide + 1} / ${slick.slideCount}`,
                                );
                            },
                        );
                    }

                    slickInitialized = true;
                }
            } else {
                if (slickInitialized) {
                    $tabsMobile.slick("unslick");
                    slickInitialized = false;
                }
                $nav.hide();
            }
        }

        handleTabsMobile();
        $(window).on("resize", handleTabsMobile);
    });
});

// Accordion toggle
jQuery(document).ready(function ($) {
    $(".js-accordion-toggle").on("click", function () {
        const $currentItem = $(this).closest(".js-accordion-item");
        const isOpen = $currentItem.hasClass("is-open");

        $(".js-accordion-item")
            .removeClass("is-open")
            .find(".js-accordion-toggle")
            .attr("aria-expanded", "false");

        if (!isOpen) {
            $currentItem.addClass("is-open");
            $(this).attr("aria-expanded", "true");
        }
    });
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".semantic-faq").forEach((group) => {
        group.addEventListener("toggle", (e) => {
            if (e.target.tagName !== "DETAILS" || !e.target.open) return;

            group.querySelectorAll("details").forEach((d) => {
                if (d !== e.target) d.removeAttribute("open");
            });
        });
    });
});

if (window.innerWidth <= 991) {
    document.querySelectorAll("details.faq-item").forEach((detail) => {
        detail.addEventListener("toggle", () => {
            if (!detail.open) return;

            setTimeout(() => {
                const yOffset = -90;
                const y =
                    detail.getBoundingClientRect().top +
                    window.pageYOffset +
                    yOffset;

                window.scrollTo({ top: y, behavior: "smooth" });
            }, 150);
        });
    });
}

//slider testimonials
jQuery(function ($) {
    const $slider = $(".slider-testimonials__track");
    const $counter = $(".slider-testimonials__counter");
    const $currentSlide = $counter.find(".current");
    const $totalSlides = $counter.find(".total");
    if (!$slider.length) return;
    if (typeof $.fn.slick !== "function") return;
    if ($slider.hasClass("slick-initialized")) return

    function debounce(fn, wait) {
        var t;
        return function () {
            clearTimeout(t);
            t = setTimeout(fn, wait);
        };
    }

    function rafThrottle(fn) {
        var running = false;
        return function () {
            if (running) return;
            running = true;
            requestAnimationFrame(function () {
                fn();
                running = false;
            });
        };
    }

    function setEqualCardHeight(slick) {
        var $cards = $(slick.$slider).find(".testimonial-card");
        if (!$cards.length) return;

        $cards.css("height", "");

        var maxH = 0;
        $cards.each(function () {
            var h = this.getBoundingClientRect().height;
            if (h > maxH) maxH = h;
        });

        $cards.css("height", maxH + "px");

        $(slick.$list).css("height", maxH + 40 + "px");
    }

    var refreshAOS = debounce(function () {
        if (typeof AOS !== "undefined") AOS.refresh();
    }, 150);

    $slider.on("init", function (event, slick, currentSlide) {
        setEqualCardHeight(slick);
        refreshAOS();

        const i = (currentSlide ? currentSlide : 0) + 1;
        $currentSlide.text(i);
        $totalSlides.text(slick.slideCount);

        $slider.find("img").one("load", function () {
            setEqualCardHeight(slick);
        });
    });

    $slider.on("afterChange", function (event, slick, currentSlide) {
        setEqualCardHeight(slick);
        refreshAOS();

        const i = currentSlide + 1;
        $currentSlide.text(i);
    });

    $slider.on(
        "setPosition",
        rafThrottle(function () {
            var slick = $slider.get(0).slick;
            if (slick) setEqualCardHeight(slick);
        }),


    );

    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        adaptiveHeight: false,
        speed: 500,
        prevArrow: $(".slider-testimonials__arrow--prev"),
        nextArrow: $(".slider-testimonials__arrow--next"),
    });

    $(window).on(
        "resize",
        debounce(function () {
            if ($slider.hasClass("slick-initialized"))
                $slider.slick("setPosition");
        }, 150),
    );
});

//slider awards
jQuery(function ($) {
    function debounce(fn, wait) {
        var t;
        return function () {
            clearTimeout(t);
            t = setTimeout(fn, wait);
        };
    }

    function equalizeLogoHeights($slider) {
        var $items = $slider.find(".logo-item");
        if (!$items.length) return;

        $items.css("min-height", "");

        var maxHeight = 0;

        $items.each(function () {
            var h = this.getBoundingClientRect().height;
            if (h > maxHeight) maxHeight = h;
        });

        $items.css("min-height", maxHeight + "px");
    }

    if (typeof $.fn.slick !== "function") return;

    $(".logos-slick").each(function () {
        var $slider = $(this);
        if ($slider.hasClass("slick-initialized")) return;

        var slideCount = $slider.children(".logo-slide").length;

        if (slideCount <= 1) {
            return;
        }

        $slider.on("init", function () {
            equalizeLogoHeights($slider);

            $slider.find("img").one("load", function () {
                equalizeLogoHeights($slider);
            });
        });

        $slider.on("afterChange", function () {
            equalizeLogoHeights($slider);
        });

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: slideCount > 1,
            infinite: true,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 2500,
            speed: 600,
            pauseOnHover: false,
            pauseOnFocus: false,
            pauseOnDotsHover: false,
            pauseOnSwipe: false,
        });
    });

    $(window).on(
        "resize",
        debounce(function () {
            $(".logos-slick.slick-initialized").each(function () {
                var $s = $(this);
                equalizeLogoHeights($s);
                $s.slick("setPosition");
            });
        }, 150),
    );
});

//open positions
jQuery(function ($) {
    const block = document.querySelector("[data-cc-embed][data-cc-src]");
    if (!block) return;

    const src = block.getAttribute("data-cc-src");
    if (!src) return;

    const placeholder = block.querySelector(".embed-placeholder");
    const mount = block.querySelector(".cc-mount") || block;

    if (block.dataset.loaded === "1") return;
    block.dataset.loaded = "1";

    window.addEventListener("load", () => {
        const s = document.createElement("script");
        s.src = src;
        s.defer = true;

        s.onload = () => {
            let tries = 0;
            const maxTries = 40;

            const check = () => {
                tries++;

                const painted = block.querySelector(
                    ".cc-jobs-container, .cc-job-container, iframe",
                );
                if (painted) {
                    if (placeholder) placeholder.remove();
                    return;
                }

                if (tries >= maxTries) {
                    if (placeholder)
                        placeholder.textContent =
                            "Widget loaded but did not render.";
                    return;
                }

                setTimeout(check, 250);
            };

            setTimeout(check, 250);
        };

        s.onerror = () => {
            if (placeholder)
                placeholder.textContent = "Could not load job widget.";
        };

        mount.appendChild(s);
    });
});

function initCustomPlaceholders(scope = document) {
    scope
        .querySelectorAll('input[placeholder*="*"], select')
        .forEach((field) => {
            let text = "";

            if (field.tagName === "INPUT") {
                if (!field.placeholder.includes("*")) return;
                text = field.placeholder.replace("*", "").trim();
                field.placeholder = "";
            }

            if (field.tagName === "SELECT") {
                const firstOption = field.options[0];
                if (!firstOption || !firstOption.text.includes("*")) return;
                text = firstOption.text.replace("*", "").trim();
                firstOption.text = "";
                firstOption.disabled = true;
                firstOption.hidden = true;
            }

            let wrapper = field.closest(".placeholder-wrapper");
            let fake;
            if (wrapper) {
                fake = wrapper.querySelector(".fake-placeholder");
                fake.innerHTML = `${text}<span class="required">*</span>`;
                return;
            }

            wrapper = document.createElement("div");
            wrapper.className = "placeholder-wrapper";
            wrapper.style.position = "relative";

            fake = document.createElement("div");
            fake.className = "fake-placeholder";
            fake.innerHTML = `${text}<span class="required">*</span>`;

            field.parentNode.insertBefore(wrapper, field);
            wrapper.appendChild(field);
            wrapper.appendChild(fake);

            const toggleFake = () => {
                fake.style.display = field.value ? "none" : "block";
            };

            toggleFake();

            field.addEventListener(
                "focus",
                () => (fake.style.display = "none"),
            );
            field.addEventListener("blur", toggleFake);
            field.addEventListener("change", toggleFake);
        });
}

document.addEventListener("DOMContentLoaded", () => {
    initCustomPlaceholders();

    // Only observe form containers for dynamic placeholder init, not the entire body
    var formContainers = document.querySelectorAll('.atr-fill-utm, .cta-form, .cta-side-form, .hero-banner-form, .form-card-with-border');
    if (formContainers.length) {
        var placeholderObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (!(node instanceof HTMLElement)) return;
                    if (node.querySelector && node.querySelector('input[placeholder*="*"], select')) {
                        initCustomPlaceholders(node);
                    }
                });
            });
        });
        formContainers.forEach(function (container) {
            placeholderObserver.observe(container, { childList: true, subtree: true });
        });
    }
});

//Anchor links 
document.querySelectorAll(".anchorlink").forEach((link) => {
    link.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = this.getAttribute("href").substring(1);
        const target = document.getElementById(targetId);
        if (!target) return;

        const offset = window.innerWidth < 992 ? 220 : 280;

        const topPos =
            target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top: topPos,
            behavior: "smooth",
        });
    });
});

window.addEventListener("load", () => {
    const hash = window.location.hash;
    if (hash) {
        const target = document.querySelector(hash);
        if (target) {
            const offset = window.innerWidth < 992 ? 220 : 280;

            const topPos =
                target.getBoundingClientRect().top +
                window.pageYOffset -
                offset;

            window.scrollTo({ top: topPos, behavior: "smooth" });
        }
    }
});
document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.search-filter-component-popup, .filter-past-events .select-events .options, .page-single-posts__content .single-sidebar .table-of-contents ul').forEach(dropdown => {
        dropdown.addEventListener('wheel', function (e) {
            e.stopPropagation();
        }, { passive: true });
    });
});
(function () {
    const targetValue = "event";
    const oldLabel = "Events";
    const newLabel = "On-Demand Webinars";

    const updateLabels = () => {
        const options = document.querySelectorAll(`[data-option-value="${targetValue}"]`);
        options.forEach(opt => {
            if (opt.textContent.trim() === oldLabel) {
                opt.textContent = newLabel;
            }
        });

        const field3 = document.querySelector('.resource-filt .search-filter-field--id-3');
        if (!field3) return;

        const selection = field3.querySelector('.search-filter-component-combobox__selection');
        if (selection) {
            const currentText = selection.textContent.trim();
            if (currentText === oldLabel) {
                selection.setAttribute('data-custom-label', newLabel);
            } else {
                selection.removeAttribute('data-custom-label');
            }
        }
    };

    // Only observe the filter container instead of entire document.body
    var filterContainer = document.querySelector('.resource-filt');
    if (filterContainer) {
        var labelObserver = new MutationObserver(updateLabels);
        labelObserver.observe(filterContainer, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }

    updateLabels();
})();

jQuery(document).ready(function($) {
    var currentUrl = window.location.href.split(/[?#]/)[0];

    $('.column-with-icons .widget_custom_html a.mega-menu-link').each(function() {
        var linkUrl = this.href.split(/[?#]/)[0];
        
        if (currentUrl === linkUrl) {
            $(this).addClass('active-custom-link');
            $(this).parents('li.mega-menu-item').addClass('mega-current-menu-ancestor');
        }
    });
});